import React from 'react'
import { useHistory } from 'react-router-dom'
import { useIdleTimer } from 'react-idle-timer'

import { logout } from 'helpers'
import { useAppState } from 'providers'

export const IdleTimeWrapper = ({ children }) => {
  const {
    appState: { user }
  } = useAppState()
  const history = useHistory()
  const handleOnIdle = event => {
    console.log('user is idle', event)
    console.log('last active', getLastActiveTime())
    logout(user?.id as string, () => history.push('/'))
  }

  const handleOnActive = event => {
    console.log('user is active', event)
    console.log('time remaining', getRemainingTime())
  }

  const handleOnAction = e => {
    // can use for user tracking if we want
    // console.log('user did something', e)
  }

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * 30,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500
  })

  return <>{children}</>
}
